import { getCashCorpMetadata } from "../metadata/cash/corp/getCashCorpMetadata";
import { getCashEquityMetadata } from "../metadata/cash/equity/getCashEquityMetadata";
import { getCashMuniMetadata } from "../metadata/cash/muni/getCashMuniMetadata";
import { getCashTBillMetadata } from "../metadata/cash/tbill/getCashTBillMetadata";
import { getCashTreasuryMetadata } from "../metadata/cash/treasury/getCashTreasuryMetadata";
import { getTransitionCorpMetadata } from "../metadata/transition/corp/getTransitionCorpMetadata";
import { getTransitionEquityMetadata } from "../metadata/transition/equity/getTransitionEquityMetadata";
import { getTransitionMuniMetadata } from "../metadata/transition/muni/getTransitionMuniMetadata";
import {
  CUSTOMIZATION_LABEL_TO_SECTION_METADATA_KEY,
  SECTIONS_METADATA,
} from "../reports";

const metadataMap = {
  cash: {
    corp: getCashCorpMetadata,
    equity: getCashEquityMetadata,
    muni: getCashMuniMetadata,
    treasury: getCashTreasuryMetadata,
    tbill: getCashTBillMetadata,
  },
  transition: {
    corp: getTransitionCorpMetadata,
    equity: getTransitionEquityMetadata,
    muni: getTransitionMuniMetadata,
    // Treasury Transition Plan report is not needed
    treasury: null,
    tbill: null,
  },
};

const getSectionMetadataKeyBy = (customizationLabel) => {
  return CUSTOMIZATION_LABEL_TO_SECTION_METADATA_KEY[customizationLabel];
};

const getStaticByCustomizationLabel = (customizationLabel) => {
  return SECTIONS_METADATA[getSectionMetadataKeyBy(customizationLabel)];
};

const getAllSectionsByType = () => {
  return metadataMap;
};

const getSectionByCustomizationLabel = (customizationLabel) => {
  const sectionMetadataKey = getSectionMetadataKeyBy(customizationLabel);
  return getAllSectionsByType()[sectionMetadataKey];
};

export const MetadataService = {
  getSectionMetadataKeyBy,
  getStaticByCustomizationLabel,
  getAllSectionsByType,
  getSectionByCustomizationLabel,
};
